import * as React from 'react'
import { Spinner } from '../ui/spinner'
import { Style } from '../../styles'

interface IProps {
  color?: string
  size?: 'small' | 'medium' | 'large'
}

const SIZES = {
  small: 14,
  medium: 20,
  large: 32,
}

export default ({ size = 'medium' }: IProps) => {
  const px = SIZES[size]

  return (
    <Spinner style={{ width: px, height: px }} />
  )
}
